<template>
  <div class="floating-action-panel-wrapper">
    <!-- 固定触发按钮 -->
    <div class="floating-trigger" v-if="!isVisible" @click="togglePanel">
      <i class="el-icon-s-unfold"></i>
    </div>

    <!-- 悬浮面板 -->
    <div class="floating-action-panel" :class="{ show: isVisible }">
      <!-- 二维码部分 -->
      <div class="qrcode-section">
        <div class="qrcode-item">
          <div class="wechat-qrcode">
            <img
              src="https://picsum.photos/100/100"
              :alt="$t('wechatQRCode')"
              class="wechat-img"
            />
          </div>
          <p class="qrcode-text" v-html="$t('scanWechatContactService')"></p>
        </div>
      </div>
      <!-- 功能按钮部分 -->
      <div class="action-buttons">
        <el-tooltip
          placement="left"
          :content="$t('servicePhone') + customerServicePhone"
          :open-delay="200"
          :close-delay="100"
          effect="dark"
        >
          <template #content>
            <div class="custom-tooltip">
              <span>{{ $t("servicePhone") }}{{ customerServicePhone }}</span>
            </div>
          </template>
          <div class="action-item" @click="contactService">
            <i class="el-icon-headset"></i>
            <span>{{ $t("customerService") }}</span>
          </div>
        </el-tooltip>

        <div class="action-item" @click="toggleCollection()">
          <i :class="isCollected ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          <span>{{ isCollected ? $t("collected") : $t("collect") }}</span>
        </div>
      </div>

      <!-- 底部控制按钮 -->
      <div class="control-buttons">
        <div class="control-item" @click="backToTop">
          <i class="el-icon-top"></i>
          <span>{{ $t("backToTop") }}</span>
        </div>
        <div class="control-item" @click="togglePanel">
          <i :class="isVisible ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
          <span>{{ isVisible ? $t("collapse") : $t("expand") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingActionPanel",
  props: {
    routeId: {
      type: [Number, String],
    },
    isCollected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: true,
      customerServicePhone: "+8621-33722221",
    };
  },
  methods: {
    // 联系客服
    contactService() {
      navigator.clipboard
        .writeText(this.customerServicePhone)
        .then(() => {
          this.$message.success(this.$t("phoneCopied"));
        })
        .catch((err) => {
          console.error("复制失败:", err);
          this.$message.error(this.$t("copyFailedPleaseRecord"));
        });
    },

    // 收藏/取消收藏方法
    toggleCollection() {
      this.$post("/collection/toggle", {
        associated_id: this.routeId,
      }).then((res) => {
        if (res.data.code === 1) {
          const newCollectedState = res.data.data.is_collected;
          this.$emit("update:isCollected", newCollectedState);
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 返回顶部
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    // 切换面板显示状态
    togglePanel() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style scoped>
.floating-action-panel-wrapper {
  position: fixed;
  right: 15px;
  bottom: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 200;
}

.floating-trigger {
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.floating-trigger:hover {
  background: #f5f7fa;
}

.floating-action-panel {
  width: 120px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  transform: translateY(100px);
  opacity: 0;
}

.floating-action-panel.show {
  transform: translateY(0);
  opacity: 1;
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.qrcode-item:last-child {
  margin-bottom: 0;
}

.qrcode-img,
.wechat-img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-bottom: 5px;
}

.wechat-qrcode {
  position: relative;
}

.wechat-logo {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.wechat-mini-logo {
  width: 20px;
  height: 20px;
}

.qrcode-text {
  text-align: center;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 5px 0;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.action-item,
.control-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  margin: 5px 0px;
  cursor: pointer;
}
.action-item {
  transition: all 0.2s;
}

.action-item:hover {
  color: #1677ff;
}

.action-item i,
.control-item i {
  font-size: 22px;
  margin-bottom: 3px;
}

.action-item ::v-deep .el-icon-star-on {
  color: #ff4d4f;
}

.action-item span {
  font-size: 10px;
}

.control-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.control-item:hover {
  color: #1677ff;
}

.control-item span {
  font-size: 10px;
}
</style>
